import { useTranslation } from 'react-i18next';
import { PARAMETERS } from '@root/tracking/constants';
import { Card, OnlyInMobile, ExpandableDescription, VideoPlayer } from '@components/shared';
import { Row, Col } from '@components/antd';
import { Landlord } from '@root/types';
import SafeRender from '@components/shared/SafeRender';
import s from './LandlordDescriptionExecutive.module.less';

export interface Props {
  landlord: Landlord;
}

export function LandlordDescriptionExecutive({ landlord }: Props) {
  const { t } = useTranslation('landlord');
  const hasExecutives = landlord.executives && landlord.executives.length > 0;

  return (
    <Row gutter={16} justify={hasExecutives ? undefined : 'center'}>
      <Col lg={16} md={16} sm={24}>
        <ExpandableDescription>
          <SafeRender unsafeContent={landlord.description}>
            <span />
          </SafeRender>
        </ExpandableDescription>

        {landlord.video ? (
          <OnlyInMobile>
            <VideoPlayer
              video={landlord.video}
              className={s.mobileVideo}
              sourcePage={PARAMETERS.landlordPage}
              sourceContent={PARAMETERS.spotlightTour}
              testId="mobileVideo"
            />
          </OnlyInMobile>
        ) : null}
      </Col>

      {hasExecutives && (
        <Col className={s.cardColumn} lg={8} md={8} sm={24}>
          <Card title={t('keyExecutives')}>
            <ul className={s.keyExecutiveList}>
              {landlord.executives!.map(executive => (
                <li key={executive}>{executive}</li>
              ))}
            </ul>
          </Card>
        </Col>
      )}
    </Row>
  );
}
